import { createChannel, createContext } from "../deps.js";
export const StoreUpdateContext = createContext("starfx:store:update", createChannel());
export const StoreContext = createContext("starfx:store");
//# sourceMappingURL=context.js.map